import React, {Component} from 'react';
import './Footer.css'
class Footer extends Component {

    render() {
        return (
                <div className='footer'>

                </div>
        )
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Calendar/Footer/Footer.js